import createFormPoster from './create-form-poster';

export { createFormPoster };



// WEBPACK FOOTER //
// ./src/index.js